import m, {Vnode} from "mithril";
import ICustomFormSettings from "../ICustomFormSettings";
import {TextboxItem} from "../../model/items/textbox";
import {CheckboxItem} from "../../model/items/checkbox";
import BasePriceTest from "./BasePriceTest";
import {ValidationError} from "../ICustomForm";

export default class PriceTestDan1 extends BasePriceTest {

    protected readonly progress;

    private readonly ci_vpausal_dtb: TextboxItem;
    private readonly ci_vpausal_trzby: TextboxItem;
    private readonly ci_pdan_pasmo: TextboxItem;
    private readonly ci_pdan_start: TextboxItem;
    private readonly ci_pdan_zdrazeni: TextboxItem;
    private readonly ci_pdan_current: TextboxItem;
    private readonly ci_pdan_next: TextboxItem;
    private readonly ci_pdan_max: TextboxItem;
    private readonly ci_progress: TextboxItem;
    //private readonly ci_testMax: TextboxItem;
    private readonly ci_trzby_konkr: TextboxItem;


    private readonly ci_finished: CheckboxItem;
    //private readonly ci_finished_min: CheckboxItem;
    private readonly ci_finished_max: CheckboxItem;
    private readonly ci_finished_dk: CheckboxItem;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        this.ci_vpausal_dtb = <TextboxItem>settings.form.grid.layout[0][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_vpausal_trzby = <TextboxItem>settings.form.grid.layout[1][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_pdan_pasmo = <TextboxItem>settings.form.grid.layout[2][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_pdan_start = <TextboxItem>settings.form.grid.layout[3][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_pdan_zdrazeni = <TextboxItem>settings.form.grid.layout[4][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_pdan_current = <TextboxItem>settings.form.grid.layout[5][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_pdan_next = <TextboxItem>settings.form.grid.layout[6][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_pdan_max = <TextboxItem>settings.form.grid.layout[7][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_progress = <TextboxItem>settings.form.grid.layout[8][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        //this.ci_testMax = <TextboxItem>settings.form.grid.layout[9][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];
        this.ci_trzby_konkr = <TextboxItem>settings.form.grid.layout[10][1]?.cellItems.filter(ci => ci instanceof TextboxItem)[0];

        this.ci_finished = <CheckboxItem>settings.form.grid.layout[11][0]?.cellItems.filter(ci => ci instanceof CheckboxItem)[0];
        this.ci_finished_max = <CheckboxItem>settings.form.grid.layout[12][0]?.cellItems.filter(ci => ci instanceof CheckboxItem)[0];
        //this.ci_finished_min = <CheckboxItem>settings.form.grid.layout[13][0]?.cellItems.filter(ci => ci instanceof CheckboxItem)[0];
        this.ci_finished_dk = <CheckboxItem>settings.form.grid.layout[14][0]?.cellItems.filter(ci => ci instanceof CheckboxItem)[0];

        this.progress = JSON.parse(this.ci_progress.getVariable() || '[]');
    }

    checkRequirements(): boolean {
        return true;
    }

    onValidationErrors(errors: ValidationError[]) {
        console.warn(errors);
    }

    protected validateAndPossiblyNextForm() {
        // do not need
    }

    protected setPrice(value: number, option: number) {
        // do not need
    }

    protected stepUp(option: number): void {
        this.makeAppearRight();
        const step = Number(this.ci_pdan_zdrazeni.getVariable());
        const teorMax = Number(this.ci_pdan_max.getVariable());
        const oldCurrent = Number(this.ci_pdan_current.getVariable());
        const oldNext = Number(this.ci_pdan_next.getVariable());

        this.progress.push([oldCurrent,oldNext,option]);
        this.ci_progress.setVariable(JSON.stringify(this.progress));

        this.ci_pdan_current.setVariable(oldNext);
        this.ci_pdan_next.setVariable(oldNext+step);

        if (oldNext >= teorMax) {
            this.ci_finished.setVariable(1);
            this.ci_finished_max.setVariable(1);
            this.settings.nextForm();
        }
    }

    protected stepDown(option: number): void {
        this.makeAppearRight();
        const oldCurrent = Number(this.ci_pdan_current.getVariable());
        const oldNext = Number(this.ci_pdan_next.getVariable());
        this.progress.push([oldCurrent,oldNext,option]);
        this.ci_progress.setVariable(JSON.stringify(this.progress));

        this.ci_finished.setVariable(1);
        this.settings.nextForm();
    }

    protected stepDK(option = 4) {
        this.makeAppearRight();
        this.setPrice(this.ci_pdan_current.getVariable(), option);
        this.ci_finished.setVariable(1);
        this.ci_finished_dk.setVariable(1);
        this.settings.nextForm();
    }

    protected viewValue(): Vnode|null {
        //m('.PriceTest-value', {}, this.ci_current.getVariable()),
        return null;
    }

    protected viewQuestion(): Vnode {
        return m('.PriceTest-question', {}, [
            m.trust(`Za předpokladu, že by se paušální daň zvýšila ze současných <b>${this.ci_pdan_start.getVariable()} Kč</b> na <b>${this.ci_pdan_next.getVariable()} Kč</b> měsíčně, přešel/a byste k výdajovému paušálu?`)
        ]);
    }

    protected viewOptions(): Vnode {
        return m('.PriceTest-controls', {}, [
            m('button.btn.large.info.outline', {
                onclick: () => this.stepUp(1),
            }, m.trust('<b>Ne, zůstal/a bych</b> u paušální daně – stále by se mi <u>finančně vyplatila</u>')),
            m('button.btn.large.info.outline', {
                onclick: () => this.stepUp(2),
            }, m.trust('<b>Ne, zůstal/a bych</b> u paušální daně – finančně by se mi nevyplatila, ale nechtěl/a bych <u>řešit administrativu navíc</u> (ročně daňové přiznání; odvod sociálního a zdravotního pojištění zvlášť)')),
            m('button.btn.large.info.outline', {
                onclick: () => this.stepDown(3),
            }, m.trust(`<b>Ano, přešel/a bych</b> k <u>výdajovému paušálu</u> ${this.ci_vpausal_dtb.getVariable()}&nbsp;% (tedy uznatelné náklady by byly ${this.ci_vpausal_trzby.getVariable()}&nbsp;Kč)`)),
            m('button.btn.large.info.outline', {
                onclick: () => this.stepDK(4),
            }, m.trust('Nevím')),
        ])
    }

    protected getQuestion(): string {
        return `<b>Za předpokladu, že by se paušální daň zvýšila (ze současných <span class="ctHighlight">${this.ci_pdan_start.getVariable()}&nbsp;Kč</span>) na <span class="ctHighlight">${this.ci_pdan_next.getVariable()}&nbsp;Kč</span> měsíčně, přešel/a byste k výdajovému paušálu?</b><br/>(předpokládejte, že vše ostatní vč. výše Vašich aktuálních příjmů by se nezměnilo)<div class="ctHint"><u>Výdajový paušál</u> = Jednou ročně dělat daňové přiznání, kde od příjmů (tržeb) si odečtete tzv. <b>výdajový paušál</b> (tj. předem dané procento z příjmů, které je určeno podle předmětu podnikání; nezáleží na tom, zda tato částka byla skutečně utracena)</div>`;
    }

}
